module.exports = __webpack_public_path__ + "static/media/img-footernav--info.ca33b1b7.png";